import React, {useState} from 'react';

import { cf } from './c_20210415a_YSh/cf';
import { ce } from './c_20210415a_YSh/ce';
import { iv } from './c_20210415a_YSh/iv';
import { ic } from './c_20210415a_YSh/ic';
import { cp } from './c_20210415a_YSh/cp';
import { ip } from './c_20210415a_YSh/ip';
import { bf } from './c_20210415a_YSh/bf';

import cView from './c_20210415a_YSh/cView';

class iSrvList extends cView {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
//alert('21:Yes We Can.'.f(
//));
  }

  $id_stss = {
    sld_it20ss: {},
  };

  $ilp_loads = () => [
/*
    ip.$ip_load_it20({
      mode: 'items',
      state: 'sld_it20ss',
      cnd: bf.q('[it20b21k]="{}" AND [it20b11k] IN (SELECT [_KEY]::TEXT FROM [t_it10] WHERE [it10b31k] IN (SELECT [_KEY]::TEXT FROM [t_it50] WHERE [it50b11k]="{}" AND [it50s110]="10"))'.f(
        global.c?.state.sgcd_pageCmns?.cm10_key,
        global.c?.state.sgcd_pageCmns?.cm20_key,
        bf.myDT_get_now(),
        bf.myDT_get_now(),
        )),
    }),
*/
/*
    ip.$ip_load_it20({
      mode: 'items',
      state: 'sld_it20ss',
      cnd: bf.q(`
        [it20b21k]="{}" AND 
        [it20b11k] IN (
          SELECT 
            [_KEY]::TEXT 
          FROM 
            [t_it10] 
          WHERE 
            [it10b31k] IN (
              SELECT 
                [_KEY]::TEXT 
              FROM 
                [t_it50] 
              WHERE 
                [it50b11k]="{}" AND 
                [it50s110]="10"
            )
        )
      `.f(
        global.c?.state.sgcd_pageCmns?.cm10_key,
        global.c?.state.sgcd_pageCmns?.cm20_key,
        bf.myDT_get_now(),
        bf.myDT_get_now(),
      )),
    }),
*/
/*
    ip.$ip_load_it20({
      mode: 'items',
      state: 'sld_it20ss',
      cnd: bf.q(`
        [it20b11k] IN (
          SELECT 
            [_KEY]::TEXT 
          FROM 
            [t_it10] 
          WHERE 
            [it10b31k] IN (
              SELECT 
                [_KEY]::TEXT 
              FROM 
                [t_it50] 
              WHERE 
                [it50s110]="10"
            )
        ) AND
        [it20b21k] IN (
          SELECT
            [_KEY]::TEXT
          FROM
            [t_cm10]
          WHERE
            [cm10i110]=(
              SELECT
                [cm10i110]
              FROM
                [t_cm10]
              WHERE
                [_KEY]={}
            )
        ) 
      `.f(
        global.c?.state.sgcd_pageCmns?.cm10_key ?? -1,
      )),
    }),
*/
    ip.$ip_load_it20({
      mode: 'items',
      state: 'sld_it20ss',
//      cnd: (global.t?.state.sgcd_pageCmns.user_key == global.t?.state.sgcd_pageCmns.cm10_key) ? // キャストの場合
      cnd: (global.c?.state.sgcd_pageCmns.userc410 == '10') ? // キャストの場合
        bf.q(`
          [it20b11k] IN (
            SELECT 
              [_KEY]::TEXT 
            FROM 
              [t_it10] 
            WHERE 
              [it10b31k] IN (
                SELECT 
                  [_KEY]::TEXT 
                FROM 
                  [t_it50] 
                WHERE 
                  [it50s110]="10"
              )
          ) AND
          [it20b21k] IN (
            SELECT
              [_KEY]::TEXT
            FROM
              [t_cm10]
            WHERE
              [cm10i110]=(
                SELECT
                  [cm10i110]
                FROM
                  [t_cm10]
                WHERE
                  [_KEY]={}
              )
          ) 
        `.f(
          global.c?.state.sgcd_pageCmns?.cm10_key ?? -1,
        ))
      : // キャストでない場合
        bf.q(`
          [it20b11k] IN (
            SELECT 
              [_KEY]::TEXT 
            FROM 
              [t_it10] 
            WHERE 
              [it10b31k] IN (
                SELECT 
                  [_KEY]::TEXT 
                FROM 
                  [t_it50] 
                WHERE 
                  [it50b11k]="{}" AND 
                  [it50s110]="10"
              )
          ) AND
          [it20b21k]="{}"
        `.f(
          global.c?.state.sgcd_pageCmns?.cm20_key,
          global.c?.state.sgcd_pageCmns?.cm10_key,
        ))
      ,
    }),
    new Promise( _o_end1 => {
      let _cnd = (global.c?.state.sgcd_pageCmns.userc410 == '10') ? // キャストの場合
        bf.q(`
          [it20b11k] IN (
            SELECT 
              [_KEY]::TEXT 
            FROM 
              [t_it10] 
            WHERE 
              [it10b31k] IN (
                SELECT 
                  [_KEY]::TEXT 
                FROM 
                  [t_it50] 
                WHERE 
                  [it50s110]="10"
              )
          ) AND
          [it20b21k] IN (
            SELECT
              [_KEY]::TEXT
            FROM
              [t_cm10]
            WHERE
              [cm10i110]=(
                SELECT
                  [cm10i110]
                FROM
                  [t_cm10]
                WHERE
                  [_KEY]={}
              )
          ) 
        `.f(
          global.c?.state.sgcd_pageCmns?.cm10_key ?? -1,
        ))
      : // キャストでない場合
        bf.q(`
          [it20b11k] IN (
            SELECT 
              [_KEY]::TEXT 
            FROM 
              [t_it10] 
            WHERE 
              [it10b31k] IN (
                SELECT 
                  [_KEY]::TEXT 
                FROM 
                  [t_it50] 
                WHERE 
                  [it50b11k]="{}" AND 
                  [it50s110]="10"
              )
          ) AND
          [it20b21k]="{}"
        `.f(
          global.c?.state.sgcd_pageCmns?.cm20_key,
          global.c?.state.sgcd_pageCmns?.cm10_key,
        ));
bf.l('235: {}'.f(_cnd))
      _o_end1();
    }),
  ];

  render() {
    return (
      <ce.RootDtl
        b_logo={false}
        b_sch={false}
        onSchEnt={null}
        b_rhtVsb={false}
        rhtIconName='plus'
        rhtPfx='新規'
        onRhtPrs={()=>{
          cf.myRN_setCmns({
            it20_key: '',
          })
          .then(() => {
            let _d_pageInfs = {
              sgc_pageRole: global.c?.state.sgc_pageRole,
              sgc_pageName: 'iSrvDtl',
              sgc_pageMode: 'new',
            };
            cf.myRN_move_fwd(_d_pageInfs);
          });
        }}
        n_bdyW={ic.gn_w}
        d_hdrs={{
          pfx: iv._get_hdrPfx('入席一覧'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            b_vsb: false,
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
              state: 'sld_it20ss',
              nextRole: global.c?.state.sgc_pageRole,
              nextPage: 'iSrvDtl',
              nextMode: 'show',
              keyName: 'it20_key',
              b_edt: false,
              b_img: false,
              b_bdr: false,
              dtmFld: 'it20d110',
//              sumFld: 'it10i210',
            },
          ]
        }}
      />
    );
  }
}

export default iSrvList;


